var MDB = window.MDB || {};;
MDB.Intake = MDB.Intake || {};
MDB.Intake.Home = MDB.Intake.Home || {};

var _config;

$.extend(MDB.Intake.Home, {
    boot: function(config) {
        _config = config;
    }
});